import { Actions } from '../constants';

export default function trigger(payload) {
  return {
    type: Actions.TRIGGER,
    meta: {
      hotjar: {
        type: 'trigger',
        payload,
      },
    },
  };
}
